import { getRuntimeConfig, isRuntimeConfigLoaded } from "@/core/runtimeConfig";

/** 当前页面主机是否可使用配置中的共享域 Cookie */
export function isCookieDomainCompatible() {
  if (!isRuntimeConfigLoaded()) {
    return true;
  }
  const domain = getRuntimeConfig().COOKIE_DOMAIN;
  if (!domain) {
    return true;
  }
  const host = window.location.hostname;
  return host === domain || host.endsWith(`.${domain}`);
}

/** 实际生效的 Cookie domain；与当前主机不匹配时不设置 domain */
export function resolveCookieDomain() {
  if (!isRuntimeConfigLoaded()) {
    return undefined;
  }
  const domain = getRuntimeConfig().COOKIE_DOMAIN;
  if (!domain || !isCookieDomainCompatible()) {
    return undefined;
  }
  return domain;
}

/**
 * SSO 仅在配置为 sso 且当前主机与 COOKIE_DOMAIN 一致时生效。
 * 部署在 IP 等非 ringdata.com 域名时自动退回站内登录，避免 SSO 死循环。
 */
export function isSsoLoginStrategy() {
  if (!isRuntimeConfigLoaded()) {
    return false;
  }
  const cfg = getRuntimeConfig();
  return cfg.LOGIN_STRATEGY === "sso" && isCookieDomainCompatible();
}
